import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    "data-qa": `checkbox-group:${$props.displayName}`
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (val, name) => {
        return (_openBlock(), _createElementBlock("div", {
          key: val,
          class: "_mt-1",
          "data-qa": `checkbox-group-id:${val}`
        }, [
          _createVNode(_component_checkbox_field, {
            "model-value": _ctx.modelValue,
            "display-name": name,
            "checked-value": val,
            inline: true,
            condensed: true,
            "read-only": $props.readOnly,
            type: $props.type,
            "onUpdate:modelValue": $options.onInput,
            "data-qa": `checkbox-group:${name}`
          }, null, 8 /* PROPS */, ["model-value", "display-name", "checked-value", "read-only", "type", "onUpdate:modelValue", "data-qa"])
        ], 8 /* PROPS */, _hoisted_1))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["data-qa"]))
}